import room1 from '../../assets/img/room1.jpg';
import room2 from '../../assets/img/room2.jpg';
import room3 from '../../assets/img/room3.jpg';
import room4 from '../../assets/img/room4.jpg';

const ImgCarouData = [
    {
        "image": room1,
        "texte": "Les Suites"
    },
    {
        "image": room2, 
        "texte": "Chambres Simples"
    },
    {
        "image": room3, 
        "texte": "etc"
    },
    {
        "image": room4,
        "texte": "etc"
    }
];
 
export default ImgCarouData;